module.exports = __webpack_public_path__ + "img/A04-20170753-001.3fe11c6e.jpg";